// extracted by mini-css-extract-plugin
module.exports = {"venueDescriptionWrap":"Card_venueDescriptionWrap__J5TSe"};